import { Injectable } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { QuestionProgressDataSource } from '@examdojo/question';
import { TopicPracticeV2Service } from './topic-practice-v2.service';

@Injectable()
export class TopicPracticeQuestionProgressDataSource implements QuestionProgressDataSource {
  constructor(private readonly topicPracticeService: TopicPracticeV2Service) {}

  readonly progressPct$ = combineLatest([
    this.topicPracticeService.isMultiQuestionActivity$,
    this.topicPracticeService.questionsSequence$,
  ]).pipe(
    map(([isMultiQuestion, questionsState]) => {
      if (!isMultiQuestion) {
        return null;
      }

      const completedCount = questionsState.filter((q) => q.isCompleted).length;
      const totalCount = questionsState.length;

      if (totalCount === 0) {
        return 0;
      }

      return 5 + (completedCount / totalCount) * 95;
    }),
  );
}
